import { render, staticRenderFns } from "./previewArea.vue?vue&type=template&id=655f549a&scoped=true&lang=pug&"
import script from "./previewArea.vue?vue&type=script&lang=js&"
export * from "./previewArea.vue?vue&type=script&lang=js&"
import style0 from "./previewArea.vue?vue&type=style&index=0&id=655f549a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f549a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('655f549a', component.options)
    } else {
      api.reload('655f549a', component.options)
    }
    module.hot.accept("./previewArea.vue?vue&type=template&id=655f549a&scoped=true&lang=pug&", function () {
      api.rerender('655f549a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview_area/previewArea.vue"
export default component.exports